import React from 'react';
import Picture from '@Theme/natucare/components/Picture/Picture';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './ArticleTile.module.scss';
const ArticleTile = ({
  href,
  picture,
  category,
  heading,
  description,
  date,
  readingTime
}) => {
  if (!href && !picture && !category && !heading && !description && !date && !readingTime) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("a", {
    href: href,
    className: styles.rootCard
  }, (picture === null || picture === void 0 ? void 0 : picture.src) && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      ...picture,
      width: 350,
      height: 227
    },
    pictureClassname: styles.rootCardPicture,
    imgClassname: styles.rootCardImage
  }), !(picture !== null && picture !== void 0 && picture.src) && /*#__PURE__*/React.createElement("div", {
    className: `${styles.rootCardPicture} ${styles.rootCardPicturePlaceholder}`
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "placeholder",
    size: {
      width: 48,
      height: 48
    }
  })), /*#__PURE__*/React.createElement("div", null, category && /*#__PURE__*/React.createElement("span", {
    className: styles.rootCardCategory
  }, category), heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootCardHeading
  }, heading), description && /*#__PURE__*/React.createElement("div", {
    className: styles.rootCardDescription
  }, description), date && date.iso && date.label && date.string && /*#__PURE__*/React.createElement("div", {
    className: styles.rootCardDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootCardDate
  }, /*#__PURE__*/React.createElement("time", {
    dateTime: date.iso
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.rootCardDateHidden
  }, date.label), date.string)), readingTime && /*#__PURE__*/React.createElement("div", {
    className: styles.rootCardReadTimeWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    classname: styles.rootCardReadTimeIcon,
    name: "readingTime",
    size: {
      width: 15,
      height: 15
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.rootCardReadTime
  }, readingTime))))));
};
export default ArticleTile;